<div class="container">
  <div class="row">
    <div class="col-12">

      <a class="d-flex justify-content-center mb-5 mt-3" routerLink="welcome">
        <img class="text-center" src="../../../assets/images/logo-blue@3x.png" style="width: 300px;">
      </a>

      <div class="mx-auto" style="max-width: 50rem;">
        <!-- Card -->
        <div class="card card-lg mb-5">
          <div class="card-body">

            <h1 class="text-center">Portail client Optitax</h1>

            <div class="alert alert-secondary d-flex align-items-center">
              <i class="fal fa-envelope"></i>
              <div class="ps-3">Si vous avez reçu un courriel de votre cabinet, vous pouvez
                utiliser le lien qui se trouve à l'intérieur.
              </div>
            </div>

            <h3>Bienvenue dans votre portail client.</h3>

            <div>Utilisez le portail pour effectuer les opérations suivantes
              <ul class="list-unstyled">
                <li class="ps-3 pt-3"><i class="fa fa-edit"></i> Remplir vos questionnaires fiscaux</li>
                <li class="ps-3 pt-3"><i class="fa fa-upload"></i> Téléverser vos documents</li>
              </ul>
            </div>

            <hr>

            <p class="text-center mt-5"><a (click)="login()" class="btn btn-primary"
                                           href="#">Connexion
              à votre
              compte</a></p>
          </div>
        </div>
        <!-- End Card -->
      </div>


    </div>
  </div>
</div>
